import axios from 'axios';
import authHeader from '../auth-header';
import baseUrl from '../base-url';

const API_URL = baseUrl() + "/api/web-view/";
const getDataAnggota = 'data-keanggotaan'
const getDataAnggotaKap = 'kap'
const getDataKategoriAnggota = 'kategori-anggota'
import tokenHeader from '../token-header';

class DataAnggotaService {

   

    getDataAnggota(pageNo, pageSize, filter, filterKategori, statusAnggota) {
        return axios.get(API_URL + getDataAnggota, {
            params: {
                pageNo,
                pageSize,
                filter,
                filterKategori, 
                statusAnggota
            },
            headers: authHeader()
        });        
    }   

    getDataAnggotaKap(pageNo, pageSize, filter, statusAnggota) {
        return axios.get(API_URL + getDataAnggotaKap, {
            params: {
                pageNo,
                pageSize,
                filter,
                statusAnggota
            },
            headers: authHeader()
        });        
    }   

    getKategoriAnggota(pageNo, pageSize, sortBy, filter,) {
        return axios.get(API_URL + getDataKategoriAnggota, {
            params: {
                pageNo,
                pageSize,
                sortBy,
                filter
            },
            headers: authHeader()
        });        
    }   

}

export default new DataAnggotaService();